export default (api) => {
  api.sms = {
    admin: {
      config: () => api.request({
        url: `/api/admin/sms/config`,
        type: 'get',
      }),
      drivers: () => api.request({
        url: `/api/admin/sms/drivers`,
        type: 'get',
      }),
      send: (params) => api.request({
        url: `/api/admin/sms/send`,
        type: 'post',
        params,
      }),
    },
  }

  api.smsLog = {
    public: {
    },
    admin: {
      index: (params = null) => api.request({
        url: `/api/admin/sms-log/index`,
        type: 'get',
        params,
      }),
      read: (id) => api.request({
        url: `/api/admin/sms-log/${id}`,
        type: 'get',
      }),
      create: (params = {}) => api.request({
        url: `/api/admin/sms-log`,
        type: 'post',
        params,
      }),
      updateAll: (id, params = {}) => api.request({
        url: `/api/admin/sms-log/${id}/all`,
        type: 'put',
        params,
      }),
      update: (id, params = {}) => api.request({
        url: `/api/admin/sms-log/${id}/update`,
        type: 'put',
        params,
      }),
      batch: (params) => api.request({
        url: `/api/admin/sms-log/batch`,
        type: 'put',
        params,
      }),
      delete: (id) => api.request({
        url: `/api/admin/sms-log/${id}`,
        type: 'delete',
      }),
      batchDelete: (params) => api.request({
        url: `/api/admin/sms-log/batch`,
        type: 'delete',
        params,
      }),
    },
  }

  api.smsDashboard = {
    admin: {
      overview: () => api.request({
        url: `/api/admin/sms-dashboard/overview`,
        type: 'get',
      }),
    },
  }
}